import React from "react";
import { useDispatch, useSelector } from "react-redux";
import SourceOptionsDB from "./SourceOptions.jsx";
import TargetOptionsDB from "./TargetOptions.jsx";
import ChooseDB from "./ChooseDB.jsx";
import DBSummary from "./DBSummary.jsx";
import "./Database-conversion.scss"
import { setCurrentStep, setSelectedSourceOption, setSelectedTargetOption } from "../../state/reducers/databaseConversion.js";
// import ConversionSummary from "./ConversionSummary.jsx";

function DatabaseConversion() {
  const currentStep = useSelector((state) => state.databaseConversion.currentStep);
  const dispatch = useDispatch();

  const resetConversion = () => {
    dispatch(setSelectedSourceOption(undefined))
    dispatch(setSelectedTargetOption(undefined))
    dispatch(setCurrentStep(1));
  }
  return (
    <>
      { currentStep === 1 && <SourceOptionsDB />}
      { currentStep === 2 && <TargetOptionsDB />}
      { currentStep === 3 && <ChooseDB />}
      { currentStep === 4 && <DBSummary resetConversion={resetConversion}/>}
      {/* { currentStep === 5 && <ConversionSummary />} */}
    </>
  );
}

export default DatabaseConversion;
  